import React from 'react'
import App from './App'

const Container: React.FC = () => {
    return (
        <div className='container'>
            <App />
        </div>
    )
}

export default Container
